// extracted by mini-css-extract-plugin
export default {"wrapperContainer":"App_wrapperContainer__OcfqC","content":"App_content__jwj1u"};